var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "main-container pa-0 pb-16"
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "65px"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('hero-home')], 1)], 1), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center",
      "align": "center",
      "dense": ""
    }
  }, [_vm._l(_vm.departmentCards, function (deptCard, key) {
    return [_c('v-col', {
      key: 'deptCard' + key,
      attrs: {
        "cols": "12",
        "sm": "4",
        "lg": "4"
      }
    }, [_c('departmentCard', _vm._b({}, 'departmentCard', deptCard, false))], 1)];
  })], 2), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center",
      "align": "center",
      "align-lg": "start",
      "justify-lg": "space-between",
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('programsCard', {
    attrs: {
      "cardColor": "primary",
      "textColor": "secondary"
    }
  }), _c('weekly-highlights-card', {
    staticClass: "mt-4"
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "cols": "12",
      "xl": "6",
      "align-self": "stretch"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "dense": "",
      "align": "start",
      "align-sm": "center",
      "justify": "center",
      "justify-md": "space-around"
    }
  }, [_vm._l(_vm.subCards, function (subCard) {
    return [_c('v-col', {
      key: subCard.id,
      staticClass: "d-flex align-center justify-center my-16 my-xl-0 pa-0",
      attrs: {
        "cols": "11",
        "md": "5",
        "xl": "9"
      }
    }, [_c('cardTile', _vm._b({}, 'cardTile', subCard, false))], 1)];
  })], 2)], 1)], 1), _c('featured-row-home'), _c('v-row', {
    staticClass: "mt-12"
  }, [_c('v-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('newMaterialCard')], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }